import { useState } from 'react';

import RecurringMaturityCalculator from './RecurringMaturityCalculator'
export default function RecurringcalculatorPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="RecurringcalculatorPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div><RecurringMaturityCalculator/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
